<template>
  <div>
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>实时公告</el-breadcrumb-item>
      <el-breadcrumb-item>新闻发布</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="queryForm" :inline="true">
      <el-form-item>
        <el-button type="primary" @click="childAdd">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-input v-model="queryForm.keyword" placeholder="关键字"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" icon="el-icon-search" circle @click="serch()"></el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
      <el-table-column
        type="index"
        width="50"
         align="center">
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        width="150"
         align="center">
      </el-table-column>
      <el-table-column
        prop="introduce"
        label="简介"
        width="150"
         align="center">
      </el-table-column>
       <el-table-column
        prop="time"
        label="立项时间"
        width="150"
         align="center">
      </el-table-column>
      <el-table-column
         align="center"
        label="封面图"
        >
        <template slot-scope="scope">
          <img class="img" :src="scope.row.image" alt="" width="200px">
        </template>
      </el-table-column>
        <el-table-column
        prop="content"
        label="内容"
        width="180"
         align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">{{scope.row.content}}</div>
              <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{scope.row.content}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
        label="权重"
        prop="order"
        width="150"
        align="center">
       </el-table-column>
       <el-table-column
            label="状态"
            width="180"
             align="center">
          <template slot-scope="scope">
              <el-button @click="isStatus(scope.row)" size="mini" :type="scope.row.status==0 ? 'success':'info'"  round  ref="button">{{scope.row.statusCH}}</el-button>
          </template>
      </el-table-column>
      <el-table-column
        label="操作"
         align="center">
        <template slot-scope="scope">
          <el-button type="success" size="small" @click="compile(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 新增修改弹框 -->
    <!-- <el-dialog
      title="提示"
      :visible.sync="childVisible"
      width="800px"
      :before-close="handleClose">
      <el-form ref="form" label-width="80px" :model="childForm">
        <el-form-item label="标题" :rules="[
          { required: true, message: '标题不能为空'},
        ]">
          <el-input maxlength="29" placeholder="最多不能超过29个汉字" v-model="childForm.title"></el-input>
        </el-form-item>
        <el-form-item label="简介" :rules="[
          { required: true, message: '简介不能为空'},
        ]">
          <el-input  placeholder="最多不能超过83个汉字" maxlength="83" v-model="childForm.intro"></el-input>
        </el-form-item>
        <el-form-item label="时间" :rules="[
          { required: true, message: '时间不能为空'},
        ]">
          <el-date-picker
            v-model="childForm.time"
            type="date"
               :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
         <el-form-item label="权重" prop="order"
         :rules="[
            { type: 'number', message: '权重必须为数字值'}
          ]">
             <el-input v-model.number="childForm.order" size="mini"></el-input>
         </el-form-item>
            <el-form-item label="是否发布" :rules="[
          { required: true, message: '不能为空'},
        ]">
             <el-select v-model="status" placeholder="请选择发布或草稿">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
               </el-option>
             </el-select>
         </el-form-item >
        <el-form-item label="封面图" :rules="[
          { required: true, message: '不能为空'},
        ]">
          <el-upload
             class="upload-demo"
             action="http://test.api.chongyi.xiaoxxx.com/admin/upload"
               accept="image/png, image/jpeg"
             :headers='headers'
             :on-success="upImgSuccess"
             ref="upload"
             multiple
             :limit="3">
            <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
             <div slot="tip" class="el-upload__tip">只能上传jpg/png文件(建议上传尺寸350*210)</div>
          </el-upload>
          <div class="visibleImg">
            <img width="60%" :src="queryForm.images" alt="">
          </div>
        </el-form-item>

        <el-form-item label="详细内容" :rules="[
          { required: true, message: '不能为空'},
        ]">
          <router-view/>
        </el-form-item>
      
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="subChild">确 定</el-button>
      </span>
    </el-dialog> -->
   
    <!--分页-->
 <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5,10,15]"
      :page-size="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
       pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
      pageVal:1,
      pageSize:5,
      currentPage: 1,
      id:'',
      total: 0,
      queryForm: {
        keyword: '',
      
        images:''
      },
       headers:{
         Authorization: ''
       },
      tableData: [
        { 
          order:'',
          date: '',
          title: '',
          address: ' ',
          intro: '',
          img: ''
        },
        {
          order:'',
          date: '',
          title: '',
          address: '',
          intro: '',
          img: ''
        },
      ],
      // childVisible: false,
      // childForm: {
      //   title: '',
      //   intro: '',
      //   time: '',
      //   order:0,
      // },
      // config: {
      //   serverUrl: `http://test.api.8think.com/ueditor/php/controller.php`,
      //   toolbars: [[
      //     'fullscreen', 'source', '|', 'undo', 'redo', '|',
      //     'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
      //     'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
      //     'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
      //     'directionalityltr', 'directionalityrtl', 'indent', '|',
      //     'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
      //     'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
      //     'insertimage', 'emotion', 'scrawl', 'insertvideo', 'music', 'attachment', 'map', 'gmap', 'insertframe', 'insertcode', 'webapp', 'pagebreak', 'template', 'background', '|',
      //     'horizontal', 'date', 'time', 'spechars', 'snapscreen', 'wordimage', '|',
      //     'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
      //     'print', 'preview', 'searchreplace', 'drafts', 'help'
      //   ]]
      // },
      // dataF: '',
      // status:'',
      // flag:1,
      //  options: [{
      //     value: 0,
      //     label: '发布'
      //   }, {
      //     value: 1,
      //     label: '草稿'
      //   }],
      // status: ''
    }
  },
  methods: {
    serch(){
       this.$http.post('/admin/notice/new/getList', {
        page: this.pageVal,
        pageSize:this.pageSize,
        noPaginate:1,
        keyword:this.queryForm.keyword
      }).then( (res)=> {
      //  console.log(res.data.data.list)
        var code=res.data.code;
        if(code===0){
          this.tableData=res.data.data.list
           this.total=res.data.data.total
        }
      }).catch(function (error) {
        //  console.log(error);
     });
    },
    isStatus(row){
         this.$confirm('是否改变状态?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            //  console.log(row.id)
              this.$http.post('/admin/notice/new/changeStatus', {
                  id:row.id
              }).then( (res)=> {
                var code=res.data.code;
                if(code===0){
                   this.$refs.button.style="background-color:none"
                    this.$message({
                      type: 'success',
                      message: '改变成功!'
                  });
                  this.getList()
                }
              }).catch(function (error) {
                // console.log(error);
                });
              }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });          
                });
    },
    childAdd () {
        // this.childVisible = true
        // this.flag=1;
        // this.$refs.upload.clearFiles();
        this.$router.push({name: 'backCaseAdd', query: {'type': 'backNews'}})
    },
    compile (row) {
      this.$router.push({name: 'backCaseEdit', query: {'type': 'backNews', 'id': row.id}})
    //     this.flag=0;
    //     this.childVisible = true;
    //     this.id=row.id
    //     this.$http.post('admin/notice/new/getInfo', {
    //         id:this.id
    //   }).then( (res)=> {
    //    console.log(res.data.data.case)
    //     var code=res.data.code;
    //     if(code===0){
    //        this.childForm.title=res.data.data.case.title;
    //        this.childForm.intro=res.data.data.case.introduce;
    //        this.childForm.order=res.data.data.case.order;
    //        this.childForm.time=res.data.data.case.time;
    //        this.queryForm.images=res.data.data.case.image;
    //        this.status=res.data.data.case.status;
    //        this.dataF=res.data.data.case.content
    //          this.$store.commit('upUeData', this.dataF)
    //        this.getList()
    //     }
    //   }).catch(function (error) {
    //      console.log(error);
    //  });
    },
    upImgSuccess (res) {
      // console.log(res)
      this.queryForm.images='https://api.treegroup-inc.com/'+res.data.url
    },
    save(){

    },
     getList () {
      this.$http.post('/admin/notice/new/getList', {
        page: this.pageVal,
        pageSize:this.pageSize,
        noPaginate:1
      }).then( (res)=> {
      //  console.log(res.data.data.list)
        var code=res.data.code;
        if(code===0){
          this.tableData=res.data.data.list
           this.total=res.data.data.total
        }
      }).catch(function (error) {
        //  console.log(error);
     });
    },
    // 关闭弹窗
    handleClose () {
      let obj = this.childForm
      let flag = false
      // 判断表单是否有填写
      for (var index in obj) {
        if (!obj[index]) {
          // console.log('无')
        } else {
          // console.log('有')
          flag = true
          break
        }
      }
      if (flag === true) {
        this.$confirm('关闭后编辑内容将撤销！')
        .then(_ => {
          this.childVisible = false
          this.childForm.title = ''
          this.childForm.intro = ''
          this.childForm.time = ''
          this.queryForm.images=''
          this.$store.commit('upUeData','')
        })
        .catch(_ => {
        });
      } else {
        this.childVisible = false
      }
    },
    // 提交
    subChild () {
      let ueData = this.$store.state.ueData
      // console.log(ueData)
      if(this.flag!=1){
         this.$http.post('/admin/notice/new/update', {
         status:this.status,
         order:this.childForm.order,
         title: this.childForm.title,
         introduce:this.childForm.intro,
         time:this.childForm.time,
         image:this.queryForm.images,
         content:this.dataF,
         id:this.id
      }).then( (res)=> {
      //  console.log(res.data.data)
        var code=res.data.code;
        if(code===0){
         this.childVisible = false
         this.$store.commit('upUeData','')
         this.$message({
              message: '编辑成功',
              type: 'success'
            });
         this.getList()
            }else if(code===-1){
              this.$message({
                showClose: true,
                message: '请检查是否填写完整',
                type: 'error'
              });
            }
           }).catch(function (error) {
        //  console.log(error);
        });
      }else{
        //新增
         this.$http.post('/admin/notice/new/create', {
              status:this.status,
              order:this.childForm.order,
              title: this.childForm.title,
              image:this.queryForm.images,
              content:this.dataF,
              introduce:this.childForm.intro,
              time:this.childForm.time,
          }).then( (res)=> {
          //  console.log(res.data.data)
            var code=res.data.code;
            if(code===0){
            this.childVisible = false
            this.$store.commit('upUeData','')
            this.$message({
              message: '新增成功',
              center: true,
               type: 'success'
            });
             this.childVisible = false
              this.childForm.title = ''
              this.childForm.intro = ''
              this.childForm.time = ''
              this.queryForm.images=''
              this.$store.commit('upUeData','')
            this.getList()
                }else if(code===-1){
               this.$message({
                showClose: true,
                message: '请检查是否填写完整',
                type: 'error'
              });
            }
              }).catch(function (error) {
            // console.log(error);
            });
          }
    },
    // 删除
    del (row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          this.id=row.id
          this.$http.post('/admin/notice/new/delete', {
           id:this.id
      }).then( (res)=> {
        var code=res.data.code;
        if(code===0){
           this.$message({
             type: 'success',
             message: '删除成功!'
        });
         this.getList()
        }
      }).catch(function (error) {
        //  console.log(error);
     });
  }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
         this.pageSize=val;
         this.getList()
      },
    handleCurrentChange(val) {
        //  console.log(`当前页: ${val}`);
         this.pageVal=val
         this.getList()
      }
  },
  
  created () {
    this.headers.Authorization= window.localStorage.getItem("user_token");
    this.getList()
  },
  mounted () {
  },
   computed: {
    getUeData() {
      return this.$store.state.ueData;
    }
  },
  watch: {
    getUeData:function(old,newd){
      // console.log(old)
      this.dataF = old;
    }
  }
}
</script>
<style scoped>
</style>
<style>
.el-pagination{
  text-align: center;
  margin-top: 50px;
}

</style>



// WEBPACK FOOTER //
// src/pages/backPages/news.vue